import { render } from "./TablaReporteBoletos.vue?vue&type=template&id=962ab62a&scoped=true"
import script from "./TablaReporteBoletos.vue?vue&type=script&lang=js"
export * from "./TablaReporteBoletos.vue?vue&type=script&lang=js"

import "./TablaReporteBoletos.vue?vue&type=style&index=0&id=962ab62a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-962ab62a"]])

export default __exports__